import React from "react";
import { Col, Container, Nav, Row } from "react-bootstrap";
import delivery from "../../assets/images/icons/delivery.png";
import pay_how_want from "../../assets/images/icons/pay_how_want.png";
import secure from "../../assets/images/icons/secure.png";
import return_14 from "../../assets/images/icons/return_14.png";

function Y_Us_StripComponent() {
  return (
    <>
      <section className="">
        <div className="p-5">
          <div className="y_us_strip">
            <Row className="gap-4">
              <Col>
                <div className="y_us_strip_col">
                  <span>
                    <img loading="lazy"  alt="" src={delivery} />
                  </span>
                  <h5>DELIVERY AS YOU NEED</h5>
                  <p>Quickly, in the locker or at home!</p>
                </div>
              </Col>
              <Col>
                <div className="y_us_strip_col">
                  <span>
                    <img loading="lazy"  alt="" src={pay_how_want} />
                  </span>
                  <h5>Choose Your Preferred Payment Method</h5>
                  <p>Online, cash on delivery, installments, cash</p>
                </div>
              </Col>
              <Col>
                <div className="y_us_strip_col">
                  <span>
                    <img loading="lazy"  alt="" src={secure} />
                  </span>
                  <h5>PRODUCT WARRANTY</h5>
                  <p>Warranty and post-warranty services</p>
                </div>
              </Col>
              {/* {window.location.search.includes("679892fa9a41ae23877db6b8") === false && (

                <Col>
                  <div className="y_us_strip_col">
                    <span>
                      <img loading="lazy"  alt="" src={return_14} />
                    </span>
                    <h5>RETURN 14 DAYS</h5>
                    <p>You have 14 days to return. Customized products are not returnable</p>
                  </div>
                </Col>
              )} */}
            </Row>
          </div>
        </div>
      </section>
    </>
  );
}

export default Y_Us_StripComponent;
